import { useState, useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { useHeaderFilters } from 'context/GlobalFiltersContext';
import { AutoReportService } from 'services/reports/endpoints/AutoReportService';
import type { FilterOption } from 'newComponents/Form/Multiselect';

export const useAgendaUsers = () => {
  const [cookie] = useCookies();
  const { headerFiltersContext } = useHeaderFilters();
  const { headerFilters } = headerFiltersContext;
  const [options, setOptions] = useState<FilterOption[]>([]);

  const search = useCallback(
    async (term: string) => {
      if (!term.trim()) {
        setOptions([]);
        return;
      }
      const empresaId = cookie.companies?.id;
      if (!empresaId) return;

      const unidadeId = headerFilters?.units?.id ? Number(headerFilters.units.id) : undefined;

      try {
        const res = await AutoReportService.searchUsers({ query: term, EmpresaId: empresaId, UnidadeId: unidadeId });
        setOptions(
          (res?.data ?? []).map((user: { nome: string; usuario: number; image?: string }) => ({
            label: user.nome,
            value: String(user.usuario),
            foto: user.image || undefined,
          })),
        );
      } catch {
        setOptions([]);
      }
    },
    [cookie, headerFilters],
  );

  return { options, search };
};
